import { KisiStatus } from "@gymflow/types";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { ModalContext, useClubSettings } from "../../../../providers";
import { ToastContext } from "../../../../providers/ToastProvider/context";
import { Button, PlusIcon, Spinner, Switch } from "../../../atoms";
import { Settings04Icon } from "../../../atoms/icons/Settings04Icon";
import { IntegrationCard } from "../components/IntegrationCard";
import { KisiIntegrationEnableModal } from "./KisiIntegrationEnableModal";
import { KisiIntegrationUpdateModal } from "./KisiIntegrationUpdateModal";

export const KisiIntegrationCard = () => {
  const { t } = useTranslation();
  const toast = useContext(ToastContext);
  const { setModal } = useContext(ModalContext);
  const { club } = useClubSettings();

  const isKisiProcessing = (
    [
      "PROCESSING_ENABLE",
      "PROCESSING_DISABLE",
      "PROCESSING_MODIFY",
    ] as KisiStatus[]
  ).includes(club?.kisiStatus ?? "DISABLED");
  return (
    <IntegrationCard
      logo={
        <div className="bg-kisi-logo size-10 rounded-lg bg-contain bg-center bg-no-repeat" />
      }
      title={t("components.integrations.kisi.card.title")}
      description={t("components.integrations.kisi.card.description")}
      switchComponent={
        isKisiProcessing || !club ? (
          <Spinner />
        ) : (
          <Switch
            value={club.kisiStatus === "ENABLED"}
            onChange={() => {
              if (club.kisiStatus === "ENABLED") {
                toast.toast({
                  message: t("components.integrations.kisi.card.disable.toast"),
                  intent: "warning",
                });
              }
              if (club.kisiStatus === "DISABLED") {
                setModal(<KisiIntegrationEnableModal />);
              }
            }}
          />
        )
      }
      footer={
        <>
          {club?.kisiStatus === "ENABLED" && (
            <Button
              className="h-fit flex-row gap-1 p-0 text-sm hover:opacity-50"
              intent="link-secondary"
              onClick={() => {
                setModal(<KisiIntegrationUpdateModal />);
              }}
            >
              <Settings04Icon />
              {t("components.integrations.kisi.card.update")}
            </Button>
          )}
          {club?.kisiStatus === "DISABLED" && (
            <Button
              className="h-fit flex-row gap-1 p-0 text-sm hover:opacity-50"
              intent="link-secondary"
              onClick={() => {
                setModal(<KisiIntegrationEnableModal />);
              }}
            >
              <PlusIcon pathClassName="stroke-secondary-500" />
              {t("components.integrations.kisi.card.enable")}
            </Button>
          )}
          {isKisiProcessing &&
            t("components.integrations.kisi.card.processing")}
        </>
      }
    />
  );
};
